// src/components/Header.jsx
import React from "react";
import { FaBars, FaArrowLeft } from "react-icons/fa";
import { useLocation } from "react-router-dom";

/**
 * Header shows:
 * - Back button (calls onBack)
 * - Hamburger (calls onToggleSidebar)
 * - Title / right icons
 *
 * Props:
 * - onToggleSidebar: function
 * - onBack: function
 */
export default function Header({ onToggleSidebar, onBack }) {
  const location = useLocation();

  return (
    <header className="bg-purple-700 text-white p-3 flex items-center justify-between shadow">
      <div className="flex items-center gap-3">
        {/* Back button (step back) */}
        <button
          onClick={onBack}
          title="Back (step)"
          className="p-2 hover:bg-purple-600 rounded"
        >
          <FaArrowLeft />
        </button>

        {/* Hamburger (toggle sidebar) */}
        <button
          onClick={onToggleSidebar}
          title="Toggle sidebar"
          className="p-2 hover:bg-purple-600 rounded md:hidden"
        >
          <FaBars />
        </button>

        <div className="font-bold text-lg ml-2">Ascent Institute</div>
      </div>

      <div className="flex items-center gap-3">
        {/* right side icons — replace/add as needed */}
        <div className="hidden md:block">📄</div>
        <div>👥</div>
      </div>
    </header>
  );
}
